import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';

import './style.scss';

/* eslint-disable camelcase, react/no-array-index-key */
export default class CSVPreview extends Component {
  static propTypes = {
    csv: PropTypes.shape({
      preview: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
      total_count: PropTypes.number,
    }),
  };

  shouldComponentUpdate(nextProps) {
    return !_isEqual(nextProps.csv, this.props.csv);
  }

  getRows = (preview = {}) =>
    Object.keys(preview).reduce(
      (acc, item, i) => {
        acc.headers[i] = item;

        preview[item].forEach((el, k) => {
          if (!acc.rows[k]) {
            acc.rows[k] = [];
          }

          acc.rows[k][i] = el;
        });

        return acc;
      },
      {
        headers: [],
        rows: [],
      },
    );

  render() {
    const { preview, total_count } = this.props.csv;
    const { headers, rows } = this.getRows(preview);

    return (
      <React.Fragment>
        <table styleName="csv-preview">
          <thead data-test="table-head">
            <tr>
              {headers.map((header, i) => (
                <th key={i}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody data-test="table-body">
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((item, k) => (
                  <td key={k}>{item}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <p styleName="total" data-test="total-rows">
          Total rows: <strong>{total_count}</strong>
        </p>
      </React.Fragment>
    );
  }
}
